module.exports = __webpack_public_path__ + "static/media/dockerkubernetes.4fa5748f.png";